import { useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { IconButton, Input, WP_ICON_NAV, type InputProps } from '@wapharma/design-system';

type PasswordInputProps = Omit<InputProps, 'type' | 'suffix'>;

export function PasswordInput(props: PasswordInputProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      {...props}
      type={visible ? 'text' : 'password'}
      suffix={
        <IconButton
          type="button"
          variant="ghost"
          size="xs"
          borderless
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? <IconEyeOff {...WP_ICON_NAV} /> : <IconEye {...WP_ICON_NAV} />}
        </IconButton>
      }
    />
  );
}
